<template>
    <span>
        <span v-show="show" class="font-14">
            <i class="fal fa-chevron-down fa-sm"></i>
        </span>
        <span v-show="!show" class="font-14">
            <i class="fal fa-chevron-right fa-sm"></i>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        }
    }
}
</script>
